import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7622
 *
 * @param {SvgIconProps} props - svg props
 */
export const BlockIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.9071 16.6218C18.9051 15.3481 19.5 13.7435 19.5 11.9999C19.5 7.85778 16.1422 4.49991 12 4.49991C10.6997 4.49991 9.47675 4.83081 8.41065 5.41299L17.2026 15.6597L17.9071 16.6218ZM16.1523 18.2466C16.0929 18.2178 16.0385 18.1769 15.9931 18.1246L6.37158 7.0429C5.20671 8.36454 4.50003 10.0997 4.50003 11.9999C4.50003 16.1421 7.8579 19.4999 12 19.4999C13.5356 19.4999 14.9634 19.0384 16.1523 18.2466Z' fill={color}/>
        </SvgIcon>
    )
}

export default BlockIcon
